import styled, {css} from 'styled-components'

export const StyledMedicalReportSectionTitle = styled.h3(
    ({theme: {typography, spacing}}) => css`
        ${typography.textXl};
        font-weight: 500;
        padding: ${spacing * 4}px ${spacing * 6}px;
    `
)
